import type { TabId } from '../types';
import { tabMeta } from '../types';

interface PortalTopbarProps {
  activeTab: TabId;
}

export default function PortalTopbar({ activeTab }: PortalTopbarProps) {
  const meta = tabMeta[activeTab];

  return (
    <header className="flex-shrink-0 h-16 border-b border-zinc-800 bg-zinc-900/60 backdrop-blur-sm flex items-center px-6 gap-4">
      <div className="flex-1 min-w-0">
        <h1 className="text-white font-bold text-base leading-none">{meta.title}</h1>
        <p className="text-zinc-500 text-xs mt-1">{meta.sub}</p>
      </div>

      <div className="flex items-center gap-3 flex-shrink-0">
        {/* Live indicator */}
        <div className="flex items-center gap-1.5 bg-emerald-500/10 border border-emerald-500/20 rounded-full px-3 py-1.5">
          <span className="w-1.5 h-1.5 bg-emerald-400 rounded-full animate-pulse flex-shrink-0" />
          <span className="text-emerald-400 text-xs font-semibold">Live</span>
        </div>

        {/* Notifications */}
        <button className="relative w-9 h-9 flex items-center justify-center rounded-xl bg-zinc-800 border border-zinc-700 hover:bg-zinc-700 cursor-pointer transition-all">
          <i className="ri-notification-3-line text-zinc-400 text-base" />
          <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-orange-500 rounded-full" />
        </button>

        {/* Avatar */}
        <div className="w-9 h-9 bg-orange-500/20 border border-orange-500/30 rounded-xl flex items-center justify-center cursor-pointer hover:bg-orange-500/30 transition-all">
          <span className="text-orange-400 text-sm font-bold">JN</span>
        </div>
      </div>
    </header>
  );
}
